export default "__VITE_ASSET__Nae20y2X__"